import { Provider as QueryProvider } from '@oai-frontend-monorepo/api';
import {
  createTheme,
  CssBaseline,
  PaletteMode,
  responsiveFontSizes,
  ThemeProvider,
} from '@mui/material';
import { useState, useMemo, useCallback } from 'react';
import { Security } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

import { getDesignTokens } from '../libs/mui';
import { oktaAuth } from '../libs/okta';
import { RestoreOriginalUriFunction } from '@okta/okta-react/bundles/types/OktaContext';
import { useUserStore } from '@oai-frontend-monorepo/state-management';
import RootErrorFallback from '../components/feedback/errors/root-error-fallback';
import {
  VITE_LEGACY_API,
  VITE_GATEWAY_API,
  VITE_MARKET_API,
  VITE_COMPANY_API,
  VITE_CLOUD_API,
  VITE_TOOLS_API,
} from '../envs';
import { ErrorBoundary } from '../components/errors/ErrorBoundary';
interface Props {
  children: React.ReactNode;
}

const Providers = ({ children }: Props) => {
  const [mode] = useState<PaletteMode>('light');

  const theme = useMemo(
    () => responsiveFontSizes(createTheme(getDesignTokens(mode))),
    [mode]
  );

  const restoreOriginalUri: RestoreOriginalUriFunction = useCallback(
    async (_oktaAuth, originalUri) => {
      window.location.assign(
        toRelativeUrl(originalUri || '/', window.location.origin)
      );
    },
    []
  );

  return (
    <ErrorBoundary fallback={RootErrorFallback}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <QueryProvider
          legacyApiBaseUrl={VITE_LEGACY_API}
          gatewayApiBaseUrl={VITE_GATEWAY_API}
          marketApiBaseUrl={VITE_MARKET_API}
          companyApiBaseUrl={VITE_COMPANY_API}
          cloudApiBaseUrl={VITE_CLOUD_API}
          toolsApiBaseUrl={VITE_TOOLS_API}
          getToken={async () => useUserStore.getState().token}
        >
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
          {/* <ReactQueryDevtools /> */}
        </QueryProvider>
      </Security>
    </ErrorBoundary>
  );
};

export default Providers;
